
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5b8Rf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ea928ff9fe82317d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $ea928ff9fe82317d$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Powered by Atlassian Intelligence',
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Powered by AI',
    'fabric.editor.ai.commandPalette.footer.disclaimerText': 'Content is based on your permissions, and its quality may vary',
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Content quality may vary',
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Uses AI. Verify results.',
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Information',
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Include knowledge from current page',
    'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence Logo',
    'fabric.editor.ai.components.backIconButton.backLabel': 'Back',
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancel',
    'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancel',
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancel',
    'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final': 'Close preview',
    'fabric.editor.ai.components.feedbackForm.badResponse': 'Bad response',
    'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback sent',
    'fabric.editor.ai.components.feedbackForm.goodResponse': 'Good response',
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Continue from last response',
    'fabric.editor.ai.config.item.action.copyResponse': 'Copy',
    'fabric.editor.ai.config.item.action.responseCopied': 'Copied!',
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copied to clipboard',
    'fabric.editor.ai.config.item.action.retryPrompt': 'Retry',
    'fabric.editor.ai.experience-application.documentInsertError': "We're having trouble inserting the response. Close the dialog and try again.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
    'fabric.editor.ai.experience.apiError': "We couldn\u2019t get a response, please try again.",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Tell AI what to do ...',
    'fabric.editor.ai.experience.inputTooShortError': 'The content is too short to summarise. Please add more and try again.',
    'fabric.editor.ai.experience.loadingAriaNewTitle': 'Analyzing',
    'fabric.editor.ai.experience.loadingAriaTitle': 'Generating',
    'fabric.editor.ai.experience.loadingEditingTitle': 'Editing',
    'fabric.editor.ai.experience.previewScreenLabel': 'Preview',
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': 'Tell Agent to write anything or choose from the below',
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo Logo',
    'fabric.editor.ai.experience.suggestionsUpdated': '{numberOfSuggestions} suggestions available for typed text',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': 'Back',
    'fabric.editor.ai.screens.discard.discardLabel': 'Discard',
    'fabric.editor.ai.screens.error.warningIconLabel': 'Warning',
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Error',
    'fabric.editor.ai.screens.error.cancelLabel': 'Cancel',
    'fabric.editor.ai.screens.error.retryLabel': 'Try again',
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Live updating content:',
    'fabric.editor.ai.screens.loading.iconAltText': 'Generating icon',
    'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Accept',
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Actions for AI generated content',
    'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Try again',
    'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
    'fabric.editor.ai.screens.preview.cancelLabel': 'Cancel',
    'fabric.editor.ai.screens.preview.compactFeedbackText': 'Helpful?',
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Tell AI what to do next',
    'fabric.editor.ai.screens.preview.discardLabel': 'Discard',
    'fabric.editor.ai.screens.preview.disclaimer': 'Information quality may vary.',
    'fabric.editor.ai.screens.preview.disclaimerLink': 'Learn why',
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Clear',
    'fabric.editor.ai.screens.preview.header.edit': 'Edit prompt',
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Edit',
    'fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip.non-final': 'This feature is not available for this AI generated response.',
    'fabric.editor.ai.screens.preview.highlightDifferencesLabel.non-final': 'Highlight differences',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Ask {agentName} what to do next',
    'fabric.editor.ai.screens.preview.refineButton': 'Refine',
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Refine',
    'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence Logo',
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': 'Submit',
    'fabric.editor.ai.screens.prompt.submitTooltip': 'Send to AI',
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - Selected',
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Remove',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Suggestions',
    'fabric.editor.ai.shared.aiProactiveDescriptor.non-final': '{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}',
    'fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final': 'Close suggested edits',
    'fabric.editor.ai.shared.aiUniversalDescriptor': 'Writing assistant',
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Let Atlassian Intelligence assist your writing',
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Write',
    'fabric.editor.ai.shared.betaLabel': 'Beta',
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
    'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NEW',
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Tell AI',
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Tell Agent'
};

});


//# sourceMappingURL=en_GB.4ffa11ad.js.map
